<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow mt-0">
            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex"
            >
              <button class="btn btn-sm btn-link" @click="$router.go(-1)">
                <i class="fa fa-chevron-left"></i> {{ $t("message.back") }}
              </button>
              <h4 class="card-title">{{ $t("message.admin.operations") }}</h4>
            </div>
            <div class="card-body px-3 py-5">
              <!-- <router-link :to="{name: 'admin-index'}" class="btn btn-sm btn-outline-primary" >{{$t('message.back')}}</router-link> -->
              <div class="text-center">
                <h1>{{ $t("message.admin.attis_status") }}: {{ status }}</h1>
                <button class="btn w-25 btn-danger" @click="confirm_stop">
                  {{ $t("message.admin.stop") }}
                </button>
                <button class="btn w-25 btn-success" @click="confirm_start">
                  {{ $t("message.admin.start") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "admin-operation",
  mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
  },
  data() {
    return {
      status: this.$t("message.admin.start"),
    };
  },
  methods: {
    /**
     * shows confirmation to check if user is sure to stop
     */
    confirm_stop() {
      this.$bvModal
        .msgBoxConfirm(this.$t("message.admin.stop_confirmation"), {
          title: this.$t("message.confirm"),
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("message.yes"),
          cancelTitle: this.$t("message.no"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          /**
           * perform stop action
           */
          this.status = this.$t("message.admin.stop");
        });
    },
    confirm_start() {
      this.$bvModal
        .msgBoxConfirm(this.$t("message.admin.start_confirmation"), {
          title: this.$t("message.confirm"),
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("message.yes"),
          cancelTitle: this.$t("message.no"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          /**
           * perform start action
           */
          this.status = this.$t("message.admin.start");
        });
    },
  },
};
</script>
